import {
  Component,
  OnInit,
  ComponentFactoryResolver,
  ViewChildren,
  QueryList,
  Input
} from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { SignatureFieldComponent } from '../signature-field/signature-field.component';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { SignatureDataEntity } from 'src/app/models/data-entities/signature-data-entity';
import { Point } from 'node_modules/signature_pad/dist/types/point';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
  selector: 'wm-signature-data-entity-view',
  templateUrl: './signature-data-entity-view.component.html',
  styleUrls: ['./signature-data-entity-view.component.css'],
  standalone: false
})
export class SignatureDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  @ViewChildren(SignatureFieldComponent) public sigs: QueryList<
    SignatureFieldComponent
  >;
  @Input() form: UntypedFormGroup;
  imageDataPath: string;
  templateForPermitForm: boolean = false;
  printedName: string;

  constructor(
    public layoutService: LayoutService,
    componentFactoryResolver: ComponentFactoryResolver,
    private _fb: UntypedFormBuilder,
    context : WorkflowContextService
  ) {
    super(layoutService, componentFactoryResolver, context);
    //added by priya 19-12-2025

    layoutService.useNewLayout$.subscribe((useNewLayout) => {
      this.templateForPermitForm = useNewLayout;
    });
    //end by priya 19-12-2025

  }

  ngOnInit() {
    let s: SignatureDataEntity;
    s = <SignatureDataEntity>this.entity;

    let value: {
      data: Array<Point[]>;
      image: string;
      path: string;
      printedName?: string;
    };

    if (typeof this.entity.value === 'string') {
      if ((this.entity.value || '') !== '' && this.entity.value.indexOf('{') !== -1) {
        value = JSON.parse(this.entity.value as string);
      }
    } else {
      value = this.entity.value;
    }

    if (value) {
      this.imageDataPath = value.image || value.path;

      this.printedName = value.printedName || '';
    }
  }
}
